import { makeToken, type Token } from "./formulaToken";
import { tokenize } from "./tokenize";

// Uses the shared lexer — no forked grammar (docs/gotchas.md § "Dual-parser parity").
// Returns null when not tokenizable (shouldn't occur — the backend gate prevents storing such a string).
export function expressionToTokens(expression: string): Token[] | null {
  const lexed = tokenize(expression);
  if (lexed === null) return null;
  return lexed.map((token) => {
    switch (token.kind) {
      case "variable":
        return makeToken("var", token.code);
      case "operator":
        return makeToken("op", token.value);
      case "openParen":
        return makeToken("paren", "(");
      case "closeParen":
        return makeToken("paren", ")");
    }
  });
}
